export const WC_PROMOTION_SETTING_CACHE_MS = 3 * 60 * 1000;

export const WC_PROMOTION_AVAILABLE_PRIZE_POOLS_CACHE_MS = 1 * 60 * 1000;

export const WC_PROMOTION_PRIZE_AMOUNT_CACHE_MS = 10 * 1000;

export const WC_PROMOTION_SPIN_HISTORY_CACHE_MS = 1 * 60 * 1000;

/** 轉盤歷程第一次請求筆數（對應 `take`） */
export const WC_PROMOTION_SPIN_HISTORY_INITIAL_TAKE = 10;

/** 轉盤歷程「載入更多」每次請求筆數 */
export const WC_PROMOTION_SPIN_HISTORY_MORE_TAKE = 20;

// site config 中的 index
export enum WcPromotionFeatureIndex {
	WeeklyLottery = 1,
	LuckySpin = 2,
	AfterParty = 3,
	LobbyBanner = 4,
	SdtAndDesktopPromotionModal = 5, // 給桌機跟手機版顯示彈窗的設定, 直接寫死在專案當中,這只是留著避免誤用
}

export const WC_PROMOTION_STATEMENT_BET_TYPE_IDS = ['17014', '17015'];

/** team id → 3-letter abbr. */
export const SOCCER_NATIONAL_TEAM_BY_ID: Record<number, string> = {
	615: 'ALG',
	18956: 'ARG',
	3397: 'AUS',
	202: 'AUT',
	254: 'BEL',
	18955: 'BRA',
	237: 'BIH',
	264: 'CAN',
	25868: 'CPV',
	267: 'COL',
	171: 'CRO',
	135130: 'CUW',
	180: 'CZE',
	2350: 'COD',
	2793: 'ECU',
	233: 'EGY',
	184: 'ENG',
	928: 'FRA',
	238: 'GER',
	1064: 'GHA',
	15269: 'HAI',
	818: 'IRN',
	987: 'IRQ',
	1257: 'CIV',
	217: 'JPN',
	4810: 'JOR',
	9917: 'KOR',
	18958: 'MEX',
	748: 'MAR',
	178: 'NED',
	216: 'NZL',
	173: 'NOR',
	708: 'PAN',
	139: 'PAR',
	182: 'POR',
	1922: 'QAT',
	2133: 'KSA',
	186: 'SCO',
	1262: 'SEN',
	214: 'RSA',
	250: 'ESP',
	916: 'SWE',
	235: 'SUI',
	169: 'TUN',
	234: 'TUR',
	152: 'URU',
	191: 'USA',
	548: 'UZB'
};
